export default {
    apiUrl: 'https://api.bound.ly',
    apiPrefix: '/',
    amplitudeApiKey: '34d9b3efc474a0c13b2c8844278dc59b',
    amplitudeServerUrl: 'https://a.bound.ly/2/httpapi',
    environment: 'production'
};
